<div class="container-fluid container-box px-0 px-md-3">
  <div class="d-flex justify-content-between">
    <span *ngIf="currentTab !== tabName.CODECROSSWALK_TAB && 
      routeUrl !== routePath.IMPORTVENDOR_ROUTEPATH && currentTab !== tabName.IMPORT_BOM_TAB"
      class="font-12 text-light-gray">
      <i class="fst-normal ps-2 p-0 text-danger">*</i>Properties required to create company: Company ,Stage ,Type ,Country ,Address Name ,Address Type ,Address Country ,Contact First Name ,Contact Last Name .
    </span>
    <span *ngIf="currentTab == tabName.CODECROSSWALK_TAB" class="font-12 text-light-gray">
      <i class="fst-normal ps-2 p-0 text-danger">*</i>Properties required.
    </span>
    <span *ngIf="routeUrl == routePath.IMPORTVENDOR_ROUTEPATH" 
      class="font-12 text-light-gray">
      <i class="fst-normal ps-2 p-0 text-danger">*</i>Properties required to create vendor: Vendor Name, Type, Country.
    </span>
    <span *ngIf="currentTab == tabName.IMPORT_BOM_TAB" class="font-12 text-light-gray">
      <i class="fst-normal ps-2 p-0 text-danger">*</i>Properties required
    </span>
    <app-button
      class="px-0"
      [button_2]="true"
      [buttonClass]="'button button-info mx-0'"
      [buttonLable]="enumButtonName.TEMPLATE_SETTING"
      (click)="openTemplateSettingModal()">
    </app-button>
  </div>
  <div class="ps-2">
    <app-ag-grid 
       class="center-Pagination d-block position-relative minHeightSet"
       [ngStyle]="{'height': flexHeight}" 
       [dataModel]="dataModel" 
       [paginations]="false"
       [columnSettings]="false"
       (gridReady)="onGridReady($event)" 
       (onSelectionChange)="onSelectionChanged($event)">
    </app-ag-grid>
  </div>
  <div class="row row-gap-2 ps-2 mt-2">
    <div class="col-12 col-lg-auto col-xl-7">
      <div class="d-flex gap-2 gap-xl-4">
        <div class="font-11 text-red fw-bold">You have {{importDocumentsService.count}} unmapped columns</div>
        <div class="font-11 text-red fw-bold">You have {{unmappedUploadedColumns?.length }} unmapped headers.
          <span class="text-secondary-color link hand font-11 text-decoration-underline bg-transparent" (click)="autoMapColumns()">View</span>
        </div>
      </div>
      <div class="font-12 text-light-gray">Unmapped columns do not get imported.</div>
    </div>
    <div class="col-12 col-lg col-xl-5 d-flex justify-content-center justify-content-sm-end align-item-center">
      <app-button *ngIf="currentTab !== tabName.CODECROSSWALK_TAB "
        class="px-1 px-sm-2"
        [button_2]="true"
        [buttonClass]="'button button-info mx-0'"
        [buttonLable]="enumButtonName.CANCEL"
        (click)="closeTab()">
      </app-button>
      <app-button *ngIf="currentTab === tabName.CODECROSSWALK_TAB "
        class="px-1 px-sm-2"
        [button_2]="true"
        [buttonClass]="'button button-info mx-0'"
        [buttonLable]="enumButtonName.CANCEL"
        (click)="close()">
      </app-button>
      <app-button
        progressStepPrev
        class="px-1 px-sm-2"
        [button_2]="true"
        [buttonClass]="'button  dark-info mx-0'"
        [buttonLable]="enumButtonName.PREVIOUS">
      </app-button>
      <app-button *ngIf="!importDocumentsService.submit"
        class="ps-1 ps-md-2 pe-0"
        (click)="passDataToDetails()"
        [button_2]="true"
        [buttonClass]="'button  dark-info mx-0'"
        [buttonLable]="enumButtonName.NEXT">
      </app-button>
      <app-button *ngIf="importDocumentsService.submit"
        class="ps-1 ps-md-2 pe-0"
        (click)="passDataToDetails()"
        [button_2]="true"
        [buttonClass]="importDocumentsService.submit?'button button-primary mx-0':'button  dark-info mx-0'"
        [buttonLable]="enumButtonName.NEXT">
      </app-button>
    </div>
  </div>
</div>